import { makeRequest } from 'utils/requestLogger';

export default (referring_user_id) =>
  makeRequest('post', '/api/referrals/create_referral', { referring_user_id });



// WEBPACK FOOTER //
// ./src/app/services/account/createReferral.js